var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-navigation-tab",on:{"click":_vm.clickItem}},[_c('img',{class:[_vm.direction != 'left' ? 'zy-navigation-tab-right' : ''],attrs:{"src":_vm.img_src}}),_c('div',{class:['zy-navigation-tab-text', _vm.select ? 'zy-navigation-tab-select' : '']},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }